// import { RelatorioService } from './../manutencao/relatorio/relatorio.service';
// import {
//   EnumTipoGrafico,
//   Grafico,
// } from './../manutencao/relatorio/models/Grafico';
// import { ModuloRelatorio } from './../manutencao/modulo-relatorio/models/modulo-relatorio';
// import { ModuloRelatorioService } from './../manutencao/modulo-relatorio/modulo-relatorio.service';
import { JwtService } from './../../structure/service/auth/jwt.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Modulo } from 'src/app/features/manutencao/modulo/models/modulo';
import { ResponseApi } from 'src/app/structure/model/response-api';
import { HomeService } from './home.service';

var columnNamespieRelatoriosMaisUtlizados = ['A', 'B'];
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  /* VARIAVEIS GLOBAIS DOS GRAFICOS  */

  width = document.documentElement.clientWidth * 0.75;
  height = document.documentElement.clientHeight * 0.6;
  // public optionspie = {
  //   is3D: true,
  //   legend: 'dsd',
  //   toolTip: {
  //     textStyle: { color: 'blue', fontName: 'Tahoma', fontSize: '17' },
  //   },
  //   fontSize: 12,
  // };
  // public optionsbar = {
  //   legend: 'dsd',
  //   toolTip: {
  //     textStyle: { color: 'blue', fontName: 'Tahoma', fontSize: '17' },
  //   },
  //   fontSize: 11,
  // };
  // public optionsArea = {
  //   legend: 'dsd',
  //   toolTip: {
  //     textStyle: { color: 'blue', fontName: 'Tahoma', fontSize: '17' },
  //   },
  //   fontSize: 11,
  // };
  // public optionsColumn = {
  //   legend: 'dsd',
  //   toolTip: {
  //     textStyle: { color: 'blue', fontName: 'Tahoma', fontSize: '17' },
  //   },
  //   fontSize: 11,
  // };

  // /*RELATORIOS MAIS  UTILIZADOS*/
  // public rowDataGraficoRelatoriosMaisUtlizados: Array<ModuloRelatorio> =
  //   new Array<ModuloRelatorio>();
  // public NaoExibirGraficoPizzaRelatoriosMaisUtlizados = true;
  // public titlepieRelatoriosMaisUtlizados = '';
  // public typepieRelatoriosMaisUtlizados = 'PieChart';
  // public columnNamespieRelatoriosMaisUtlizados = ['A', 'B'];
  // public datapieRelatoriosMaisUtlizados = [['1900', 0]];

  // /* VARIAVEIS PIZZAS 10 UNIDADES*/
  // public titlepie1 = 'Grafico Pizza';
  // public typepie1 = 'PieChart';
  // public columnNamespie1 = ['A', 'B'];
  // public datapie1 = [['1900', 0]];

  // public titlepie2 = 'Grafico Pizza';
  // public typepie2 = 'PieChart';
  // public columnNamespie2 = ['A', 'B'];
  // public datapie2 = [['1900', 0]];

  // public titlepie3 = 'Grafico Pizza';
  // public typepie3 = 'PieChart';
  // public columnNamespie3 = ['A', 'B'];
  // public datapie3 = [['1900', 0]];

  // public titlepie4 = 'Grafico Pizza';
  // public typepie4 = 'PieChart';
  // public columnNamespie4 = ['A', 'B'];
  // public datapie4 = [['1900', 0]];

  // public titlepie5 = 'Grafico Pizza';
  // public typepie5 = 'PieChart';
  // public columnNamespie5 = ['A', 'B'];
  // public datapie5 = [['1900', 0]];

  // public titlepie6 = 'Grafico Pizza';
  // public typepie6 = 'PieChart';
  // public columnNamespie6 = ['A', 'B'];
  // public datapie6 = [['1900', 0]];

  // public titlepie7 = 'Grafico Pizza';
  // public typepie7 = 'PieChart';
  // public columnNamespie7 = ['A', 'B'];
  // public datapie7 = [['1900', 0]];

  // public titlepie8 = 'Grafico Pizza';
  // public typepie8 = 'PieChart';
  // public columnNamespie8 = ['A', 'B'];
  // public datapie8 = [['1900', 0]];

  // public titlepie9 = 'Grafico Pizza';
  // public typepie9 = 'PieChart';
  // public columnNamespie9 = ['A', 'B'];
  // public datapie9 = [['1900', 0]];

  // public titlepie10 = 'Grafico Pizza';
  // public typepie10 = 'PieChart';
  // public columnNamespie10 = ['A', 'B'];
  // public datapie10 = [['1900', 0]];

  // public NaoExibirPieGrafico1 = true;
  // public NaoExibirPieGrafico2 = true;
  // public NaoExibirPieGrafico3 = true;
  // public NaoExibirPieGrafico4 = true;
  // public NaoExibirPieGrafico5 = true;
  // public NaoExibirPieGrafico6 = true;
  // public NaoExibirPieGrafico7 = true;
  // public NaoExibirPieGrafico8 = true;
  // public NaoExibirPieGrafico9 = true;
  // public NaoExibirPieGrafico10 = true;

  // /* VARIAVEIS BARRAS 10 UNIDADES*/
  // public titleBar1 = 'Grafico Barras';
  // public typeBar1 = 'BarChart';
  // public columnNamesBar1 = ['A', 'B'];
  // public dataBar1 = [['1900', 0]];

  // public titleBar2 = 'Grafico Barras';
  // public typeBar2 = 'BarChart';
  // public columnNamesBar2 = ['A', 'B'];
  // public dataBar2 = [['1900', 0]];

  // public titleBar3 = 'Grafico Barras';
  // public typeBar3 = 'BarChart';
  // public columnNamesBar3 = ['A', 'B'];
  // public dataBar3 = [['1900', 0]];

  // public titleBar4 = 'Grafico Barras';
  // public typeBar4 = 'BarChart';
  // public columnNamesBar4 = ['A', 'B'];
  // public dataBar4 = [['1900', 0]];

  // public titleBar5 = 'Grafico Barras';
  // public typeBar5 = 'BarChart';
  // public columnNamesBar5 = ['A', 'B'];
  // public dataBar5 = [['1900', 0]];

  // public titleBar6 = 'Grafico Barras';
  // public typeBar6 = 'BarChart';
  // public columnNamesBar6 = ['A', 'B'];
  // public dataBar6 = [['1900', 0]];

  // public titleBar7 = 'Grafico Barras';
  // public typeBar7 = 'BarChart';
  // public columnNamesBar7 = ['A', 'B'];
  // public dataBar7 = [['1900', 0]];

  // public titleBar8 = 'Grafico Barras';
  // public typeBar8 = 'BarChart';
  // public columnNamesBar8 = ['A', 'B'];
  // public dataBar8 = [['1900', 0]];

  // public titleBar9 = 'Grafico Barras';
  // public typeBar9 = 'BarChart';
  // public columnNamesBar9 = ['A', 'B'];
  // public dataBar9 = [['1900', 0]];

  // public titleBar10 = 'Grafico Barras';
  // public typeBar10 = 'BarChart';
  // public columnNamesBar10 = ['A', 'B'];
  // public dataBar10 = [['1900', 0]];

  // public NaoExibirBarGrafico1 = true;
  // public NaoExibirBarGrafico2 = true;
  // public NaoExibirBarGrafico3 = true;
  // public NaoExibirBarGrafico4 = true;
  // public NaoExibirBarGrafico5 = true;
  // public NaoExibirBarGrafico6 = true;
  // public NaoExibirBarGrafico7 = true;
  // public NaoExibirBarGrafico8 = true;
  // public NaoExibirBarGrafico9 = true;
  // public NaoExibirBarGrafico10 = true;

  // /* VARIAVEIS AREA 10 UNIDADES*/
  // public titleArea1 = 'Grafico Area';
  // public typeArea1 = 'AreaChart';
  // public columnNamesArea1 = ['A', 'B'];
  // public dataArea1 = [['1900', 0]];

  // public titleArea2 = 'Grafico Area';
  // public typeArea2 = 'AreaChart';
  // public columnNamesArea2 = ['A', 'B'];
  // public dataArea2 = [['1900', 0]];

  // public titleArea3 = 'Grafico Area';
  // public typeArea3 = 'AreaChart';
  // public columnNamesArea3 = ['A', 'B'];
  // public dataArea3 = [['1900', 0]];

  // public titleArea4 = 'Grafico Area';
  // public typeArea4 = 'AreaChart';
  // public columnNamesArea4 = ['A', 'B'];
  // public dataArea4 = [['1900', 0]];

  // public titleArea5 = 'Grafico Area';
  // public typeArea5 = 'AreaChart';
  // public columnNamesArea5 = ['A', 'B'];
  // public dataArea5 = [['1900', 0]];

  // public titleArea6 = 'Grafico Area';
  // public typeArea6 = 'AreaChart';
  // public columnNamesArea6 = ['A', 'B'];
  // public dataArea6 = [['1900', 0]];

  // public titleArea7 = 'Grafico Area';
  // public typeArea7 = 'AreaChart';
  // public columnNamesArea7 = ['A', 'B'];
  // public dataArea7 = [['1900', 0]];

  // public titleArea8 = 'Grafico Area';
  // public typeArea8 = 'AreaChart';
  // public columnNamesArea8 = ['A', 'B'];
  // public dataArea8 = [['1900', 0]];

  // public titleArea9 = 'Grafico Area';
  // public typeArea9 = 'AreaChart';
  // public columnNamesArea9 = ['A', 'B'];
  // public dataArea9 = [['1900', 0]];

  // public titleArea10 = 'Grafico Area';
  // public typeArea10 = 'AreaChart';
  // public columnNamesArea10 = ['A', 'B'];
  // public dataArea10 = [['1900', 0]];

  // public NaoExibirAreaGrafico1 = true;
  // public NaoExibirAreaGrafico2 = true;
  // public NaoExibirAreaGrafico3 = true;
  // public NaoExibirAreaGrafico4 = true;
  // public NaoExibirAreaGrafico5 = true;
  // public NaoExibirAreaGrafico6 = true;
  // public NaoExibirAreaGrafico7 = true;
  // public NaoExibirAreaGrafico8 = true;
  // public NaoExibirAreaGrafico9 = true;
  // public NaoExibirAreaGrafico10 = true;

  // /* VARIAVEIS Column 10 UNIDADES*/
  // public titleColumn1 = 'Grafico Column';
  // public typeColumn1 = 'ColumnChart';
  // public columnNamesColumn1 = ['A', 'B'];
  // public dataColumn1 = [['1900', 0]];

  // public titleColumn2 = 'Grafico Column';
  // public typeColumn2 = 'ColumnChart';
  // public columnNamesColumn2 = ['A', 'B'];
  // public dataColumn2 = [['1900', 0]];

  // public titleColumn3 = 'Grafico Column';
  // public typeColumn3 = 'ColumnChart';
  // public columnNamesColumn3 = ['A', 'B'];
  // public dataColumn3 = [['1900', 0]];

  // public titleColumn4 = 'Grafico Column';
  // public typeColumn4 = 'ColumnChart';
  // public columnNamesColumn4 = ['A', 'B'];
  // public dataColumn4 = [['1900', 0]];

  // public titleColumn5 = 'Grafico Column';
  // public typeColumn5 = 'ColumnChart';
  // public columnNamesColumn5 = ['A', 'B'];
  // public dataColumn5 = [['1900', 0]];

  // public titleColumn6 = 'Grafico Column';
  // public typeColumn6 = 'ColumnChart';
  // public columnNamesColumn6 = ['A', 'B'];
  // public dataColumn6 = [['1900', 0]];

  // public titleColumn7 = 'Grafico Column';
  // public typeColumn7 = 'ColumnChart';
  // public columnNamesColumn7 = ['A', 'B'];
  // public dataColumn7 = [['1900', 0]];

  // public titleColumn8 = 'Grafico Column';
  // public typeColumn8 = 'ColumnChart';
  // public columnNamesColumn8 = ['A', 'B'];
  // public dataColumn8 = [['1900', 0]];

  // public titleColumn9 = 'Grafico Column';
  // public typeColumn9 = 'ColumnChart';
  // public columnNamesColumn9 = ['A', 'B'];
  // public dataColumn9 = [['1900', 0]];

  // public titleColumn10 = 'Grafico Column';
  // public typeColumn10 = 'ColumnChart';
  // public columnNamesColumn10 = ['A', 'B'];
  // public dataColumn10 = [['1900', 0]];

  // public NaoExibirColumnGrafico1 = true;
  // public NaoExibirColumnGrafico2 = true;
  // public NaoExibirColumnGrafico3 = true;
  // public NaoExibirColumnGrafico4 = true;
  // public NaoExibirColumnGrafico5 = true;
  // public NaoExibirColumnGrafico6 = true;
  // public NaoExibirColumnGrafico7 = true;
  // public NaoExibirColumnGrafico8 = true;
  // public NaoExibirColumnGrafico9 = true;
  // public NaoExibirColumnGrafico10 = true;

  isServerError = false;
  isSpinner = true;

  public browserName: string = '';
  public browserVersion: string = '';

  constructor(
    private homeService: HomeService,
    private router: Router,
    private jwtService: JwtService,
    // public moduloRelatorioService: ModuloRelatorioService,
    // public relatorioService: RelatorioService
  ) {}

  ngOnInit(): void {
    // debugger;
    this.DadosNavedaor();
    var usuarioLogado = this.jwtService.getUsuarioDadosJSON();
  }

  ngAfterViewInit(): void {}

  resetWindowsSize(event: any) {
    this.width = event.target.innerWidth * 0.75;
    this.height = event.target.innerHeight * 0.6;
  }

  onNavigate(rota: string): void {
    this.router.navigate([`${rota}`]);
  }

  onNomeUsuario() {
    var usuario = this.jwtService.getUsuarioDadosJSON();
    return usuario.Nome + ' ' + usuario.SobreNome;
  }

  onDataHoje() {
    var data = new Date();
    return data.toLocaleDateString('pt-br', { timeZone: 'UTC' });
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  detectBrowserVersion() {
    var userAgent = navigator.userAgent,
      tem,
      matchTest =
        userAgent.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2]
      ? [matchTest[1], matchTest[2]]
      : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null)
      matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }

  DadosNavedaor() {
    debugger;
    // this.browserName = this.detectBrowserName();
    // this.browserVersion = this.detectBrowserVersion();
    let versionStartIndex = 0;
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('chrome')) {
      this.browserName = 'Google Chrome';
      versionStartIndex = userAgent.indexOf('chrome') + 'chrome'.length + 1;
    } else if (userAgent.includes('firefox')) {
      this.browserName = 'Mozilla Firefox';
      versionStartIndex = userAgent.indexOf('firefox') + 'firefox'.length + 1;
    } else if (userAgent.includes('safari')) {
      this.browserName = 'Apple Safari';
      versionStartIndex = userAgent.indexOf('safari') + 'safari'.length + 1;
    } else if (userAgent.includes('opera')) {
      this.browserName = 'Opera';
      versionStartIndex = userAgent.indexOf('opera') + 'opera'.length + 1;
    } else if (userAgent.includes('opr')) {
      this.browserName = 'Opera';
      versionStartIndex = userAgent.indexOf('opr') + 'opr'.length + 1;
    } else if (userAgent.includes('edge')) {
      this.browserName = 'Microsoft Edge';
      versionStartIndex = userAgent.indexOf('edge') + 'edge'.length + 1;
    } else if (userAgent.includes('msie')) {
      this.browserName = 'Internet Explorer';
      versionStartIndex = userAgent.indexOf('msie') + 'msie'.length + 1;
    } else if (userAgent.includes('trident')) {
      this.browserName = 'Internet Explorer';
      versionStartIndex = userAgent.indexOf('trident') + 'trident'.length + 1;
    } else {
      this.browserName = 'Unknown';
    }
    if (versionStartIndex > 0)
      this.browserVersion = userAgent
        .substring(versionStartIndex)
        .split(' ')[0];
  }
}
